const S = (t, e) => e.some((r) => t instanceof r);
let O, v;
function N() {
  return O || (O = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function H() {
  return v || (v = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const R = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
function k(t) {
  const e = new Promise((r, n) => {
    const o = () => {
      t.removeEventListener("success", a), t.removeEventListener("error", i);
    }, a = () => {
      r(d(t.result)), o();
    }, i = () => {
      n(t.error), o();
    };
    t.addEventListener("success", a), t.addEventListener("error", i);
  });
  return T.set(e, t), e;
}
function $(t) {
  if (R.has(t))
    return;
  const e = new Promise((r, n) => {
    const o = () => {
      t.removeEventListener("complete", a), t.removeEventListener("error", i), t.removeEventListener("abort", i);
    }, a = () => {
      r(), o();
    }, i = () => {
      n(t.error || new DOMException("AbortError", "AbortError")), o();
    };
    t.addEventListener("complete", a), t.addEventListener("error", i), t.addEventListener("abort", i);
  });
  R.set(t, e);
}
let L = {
  get(t, e, r) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return R.get(t);
      if (e === "store")
        return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return d(t[e]);
  },
  set(t, e, r) {
    return t[e] = r, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function x(t) {
  L = t(L);
}
function j(t) {
  return H().includes(t) ? function(...e) {
    return t.apply(M(this), e), d(this.request);
  } : function(...e) {
    return d(t.apply(M(this), e));
  };
}
function U(t) {
  return typeof t == "function" ? j(t) : (t instanceof IDBTransaction && $(t), S(t, N()) ? new Proxy(t, L) : t);
}
function d(t) {
  if (t instanceof IDBRequest)
    return k(t);
  if (D.has(t))
    return D.get(t);
  const e = U(t);
  return e !== t && (D.set(t, e), T.set(e, t)), e;
}
const M = (t) => T.get(t);
function Q(t, e, { blocked: r, upgrade: n, blocking: o, terminated: a } = {}) {
  const i = indexedDB.open(t, e), c = d(i);
  return n && i.addEventListener("upgradeneeded", (s) => {
    n(d(i.result), s.oldVersion, s.newVersion, d(i.transaction), s);
  }), r && i.addEventListener("blocked", (s) => r(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    s.oldVersion,
    s.newVersion,
    s
  )), c.then((s) => {
    a && s.addEventListener("close", () => a()), o && s.addEventListener("versionchange", (u) => o(u.oldVersion, u.newVersion, u));
  }).catch(() => {
  }), c;
}
const W = ["get", "getKey", "getAll", "getAllKeys", "count"], G = ["put", "add", "delete", "clear"], I = /* @__PURE__ */ new Map();
function C(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (I.get(e))
    return I.get(e);
  const r = e.replace(/FromIndex$/, ""), n = e !== r, o = G.includes(r);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(r in (n ? IDBIndex : IDBObjectStore).prototype) || !(o || W.includes(r))
  )
    return;
  const a = async function(i, ...c) {
    const s = this.transaction(i, o ? "readwrite" : "readonly");
    let u = s.store;
    return n && (u = u.index(c.shift())), (await Promise.all([
      u[r](...c),
      o && s.done
    ]))[0];
  };
  return I.set(e, a), a;
}
x((t) => ({
  ...t,
  get: (e, r, n) => C(e, r) || t.get(e, r, n),
  has: (e, r) => !!C(e, r) || t.has(e, r)
}));
const X = ["continue", "continuePrimaryKey", "advance"], F = {}, A = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakMap(), K = {
  get(t, e) {
    if (!X.includes(e))
      return t[e];
    let r = F[e];
    return r || (r = F[e] = function(...n) {
      A.set(this, z.get(this)[e](...n));
    }), r;
  }
};
async function* Y(...t) {
  let e = this;
  if (e instanceof IDBCursor || (e = await e.openCursor(...t)), !e)
    return;
  e = e;
  const r = new Proxy(e, K);
  for (z.set(r, e), T.set(r, M(e)); e; )
    yield r, e = await (A.get(r) || e.continue()), A.delete(r);
}
function P(t, e) {
  return e === Symbol.asyncIterator && S(t, [IDBIndex, IDBObjectStore, IDBCursor]) || e === "iterate" && S(t, [IDBIndex, IDBObjectStore]);
}
x((t) => ({
  ...t,
  get(e, r, n) {
    return P(e, r) ? Y : t.get(e, r, n);
  },
  has(e, r) {
    return P(e, r) || t.has(e, r);
  }
}));
const q = "0.0.373-alpha.23", Z = {
  version: q
}, V = "mediaCachingDB", h = "mediaStore", E = "__cache_flag__", J = 1, g = !1, y = Z.version;
let f = null, b = !1, m = null;
class ee {
  logs = [];
  logTimeout = null;
  LOG_DELAY = 2e3;
  // 2 seconds delay for debounced logging
  MAX_LOGS = 100;
  // Maximum logs to keep in memory
  addLog(e) {
    const r = {
      ...e,
      timestamp: Date.now()
    };
    this.logs.push(r), this.logs.length > this.MAX_LOGS && (this.logs = this.logs.slice(-this.MAX_LOGS)), this.scheduleLogging();
  }
  scheduleLogging() {
    this.logTimeout && clearTimeout(this.logTimeout), this.logTimeout = setTimeout(() => {
      this.printLogs();
    }, this.LOG_DELAY);
  }
  printLogs() {
  }
  groupLogsByOperation() {
    const e = {};
    return this.logs.forEach((r) => {
      e[r.operation] || (e[r.operation] = []), e[r.operation].push(r);
    }), e;
  }
  getOperationDisplay(e) {
    switch (e) {
      case "HIT":
        return "✅ HIT";
      case "MISS":
        return "⚠️ MISS";
      case "SAVE":
        return "💾 SAVE";
      case "ERROR":
        return "❌ ERROR";
      default:
        return e;
    }
  }
  truncateUrl(e, r) {
    return e.length <= r ? e : e.substring(0, r - 3) + "...";
  }
  printEnhancedSummary() {
    const e = this.logs.reduce(
      (a, i) => (a.total++, i.size && (a.totalSize += i.size), i.duration && (a.totalDuration += i.duration, a.minDuration = Math.min(a.minDuration, i.duration), a.maxDuration = Math.max(a.maxDuration, i.duration)), a[i.operation] = (a[i.operation] || 0) + 1, a),
      {
        total: 0,
        totalSize: 0,
        totalDuration: 0,
        minDuration: Number.POSITIVE_INFINITY,
        maxDuration: 0,
        HIT: 0,
        MISS: 0,
        SAVE: 0,
        ERROR: 0
      }
    );
    if (e.total === 0) return;
    const r = e.totalDuration / e.total, n = e.total > 0 ? (e.HIT / e.total * 100).toFixed(1) : "0", o = [
      {
        metric: "Total Operations",
        value: e.total,
        percentage: "100%",
        performance: `${r.toFixed(1)}ms avg`
      },
      {
        metric: "Cache Hits",
        value: e.HIT,
        percentage: `${n}%`,
        performance: "✅ Optimal"
      },
      {
        metric: "Cache Misses",
        value: e.MISS,
        percentage: `${e.total ? (e.MISS / e.total * 100).toFixed(1) : "0"}%`,
        performance: "⚠️ Network"
      },
      {
        metric: "New Saves",
        value: e.SAVE,
        percentage: `${e.total ? (e.SAVE / e.total * 100).toFixed(1) : "0"}%`,
        performance: "💾 Storage"
      },
      {
        metric: "Errors",
        value: e.ERROR,
        percentage: `${e.total ? (e.ERROR / e.total * 100).toFixed(1) : "0"}%`,
        performance: e.ERROR ? "❌ Issues" : "✅ Clean"
      },
      {
        metric: "Total Data Size",
        value: `${(e.totalSize / 1024).toFixed(1)} KB`,
        percentage: "N/A",
        performance: "📦 Storage"
      },
      {
        metric: "Performance Range",
        value: `${isFinite(e.minDuration) ? e.minDuration.toFixed(1) : "0"}-${e.maxDuration.toFixed(1)}ms`,
        percentage: "N/A",
        performance: "⚡ Speed"
      }
    ];
    console.table(o);
  }
  // Force immediate logging (for debugging)
  forceLog() {
    this.logTimeout && (clearTimeout(this.logTimeout), this.logTimeout = null), this.printLogs();
  }
  // Clear all logs
  clear() {
    this.logs = [], this.logTimeout && (clearTimeout(this.logTimeout), this.logTimeout = null);
  }
}
const l = new ee();
async function w() {
  if (f)
    return f;
  try {
    return f = await Q(V, J, {
      upgrade(t, e, r) {
        g && console.warn(`Upgrading IndexedDB from version ${e} to ${r}`), t.objectStoreNames.contains(h) || t.createObjectStore(h);
      },
      blocked() {
      },
      blocking() {
      }
    }), f;
  } catch (t) {
    throw t;
  }
}
async function B() {
  try {
    const t = await w();
    if (!t) throw new Error("Failed to initialize database");
    await t.put(h, y, E);
  } catch (t) {
    throw t;
  }
}
async function ie() {
  return m || (b ? Promise.resolve() : (m = te(), m));
}
async function te() {
  try {
    const t = await w();
    if (!t) throw new Error("Failed to initialize database");
    const e = await t.get(h, E);
    e === void 0 ? await B() : e !== y && await B(), b = !0;
  } catch {
    try {
      await B(), b = !0;
    } catch (e) {
      throw b = !1, m = null, e;
    }
  }
}
async function re(t) {
  const e = performance.now();
  try {
    const r = await w();
    if (!r)
      return l.addLog({
        url: t,
        operation: "ERROR",
        error: "Failed to initialize database",
        duration: performance.now() - e
      }), null;
    const n = await r.get(h, t), o = performance.now() - e;
    return n ? (l.addLog({
      url: t,
      operation: "HIT",
      size: typeof n == "string" ? new Blob([n]).size : 0,
      duration: o
    }), n) : (l.addLog({
      url: t,
      operation: "MISS",
      duration: o
    }), null);
  } catch (r) {
    const n = performance.now() - e;
    return r instanceof Error && r.name === "VersionError" ? (await ne(), l.addLog({
      url: t,
      operation: "ERROR",
      error: "VersionError - database reset",
      duration: n
    }), null) : (l.addLog({
      url: t,
      operation: "ERROR",
      error: r instanceof Error ? r.message : "Unknown error",
      duration: n
    }), null);
  }
}
async function _(t, e) {
  const r = performance.now();
  try {
    const n = await w();
    if (!n)
      throw l.addLog({
        url: t,
        operation: "ERROR",
        error: "Failed to initialize database",
        duration: performance.now() - r
      }), new Error("Failed to initialize database");
    const o = new Blob([e]).size;
    await n.put(h, e, t), await n.get(h, E) !== y && await n.put(h, y, E);
    const i = performance.now() - r;
    l.addLog({
      url: t,
      operation: "SAVE",
      size: o,
      duration: i
    });
  } catch (n) {
    const o = performance.now() - r;
    throw l.addLog({
      url: t,
      operation: "ERROR",
      error: n instanceof Error ? n.message : "Unknown error",
      duration: o
    }), n;
  }
}
async function se(t) {
  try {
    const e = await w();
    if (!e) throw new Error("Failed to initialize database");
    await e.delete(h, t);
  } catch (e) {
    throw e;
  }
}
async function ne() {
  try {
    f = null;
    const t = indexedDB.deleteDatabase(V);
    await new Promise((e, r) => {
      t.onsuccess = () => e(), t.onerror = () => r(t.error), t.onblocked = () => {
        g && console.warn("Database deletion blocked - close other tabs using this database"), r(new Error("Database deletion blocked"));
      };
    });
  } catch (t) {
    throw t;
  }
}
class oe {
  batchQueue = [];
  batchTimeout = null;
  BATCH_DELAY = 50;
  // 50ms delay to collect requests
  MAX_BATCH_SIZE = 10;
  // Maximum requests per batch
  MAX_BATCH_WAIT = 100;
  // Maximum wait time for batch
  async addRequest(e) {
    return new Promise((r, n) => {
      const o = {
        url: e,
        resolve: r,
        reject: n,
        timestamp: Date.now()
      };
      this.batchQueue.push(o), this.batchQueue.length >= this.MAX_BATCH_SIZE ? this.processBatch() : this.batchTimeout || (this.batchTimeout = setTimeout(() => {
        this.processBatch();
      }, this.BATCH_DELAY));
    });
  }
  async processBatch() {
    if (this.batchTimeout && (clearTimeout(this.batchTimeout), this.batchTimeout = null), this.batchQueue.length === 0) return;
    const e = this.batchQueue.splice(0, this.MAX_BATCH_SIZE), r = e.map((o) => o.url), n = [...new Set(r)];
    try {
      const o = await this.fetchBatch(n);
      e.forEach((a) => {
        const i = o.get(a.url);
        i !== void 0 ? a.resolve(i) : a.reject(new Error("Request not found in batch results"));
      });
    } catch (o) {
      e.forEach((a) => {
        a.reject(o);
      });
    }
  }
  async fetchBatch(e) {
    const r = /* @__PURE__ */ new Map(), n = e.map(async (c) => {
      try {
        const s = await re(c);
        return { url: c, result: s };
      } catch (s) {
        return { url: c, result: null, error: s };
      }
    }), o = await Promise.all(n), a = /* @__PURE__ */ new Set();
    o.forEach(({ url: c, result: s }) => {
      s && (r.set(c, s), a.add(c));
    });
    const i = e.filter((c) => !a.has(c));
    if (i.length > 0) {
      const c = i.map(async (u) => {
        try {
          const p = await this.fetchSingleResource(u);
          return { url: u, result: p };
        } catch {
          return { url: u, result: null };
        }
      });
      (await Promise.all(c)).forEach(({ url: u, result: p }) => {
        r.set(u, p);
      });
    }
    return r;
  }
  async fetchSingleResource(e) {
    try {
      const r = await fetch(e);
      if (!r.ok)
        throw new Error(`HTTP error! status: ${r.status}`);
      const n = r.headers.get("Content-Type");
      if (!n)
        throw new Error("No content type received");
      if (n.includes("image/svg+xml")) {
        const o = await r.text();
        return await _(e, o), o;
      }
      if (n.includes("image/")) {
        const o = await r.blob();
        if (!o || o.size === 0)
          throw new Error("Invalid or empty blob received from server");
        const a = await this.blobToBase64(o);
        return await _(e, a), a;
      }
      throw new Error(`Unsupported content type: ${n}`);
    } catch {
      return null;
    }
  }
  blobToBase64(e) {
    return new Promise((r, n) => {
      const o = new FileReader();
      o.onload = () => r(o.result), o.onerror = n, o.readAsDataURL(e);
    });
  }
  // Force process any pending requests
  forceProcess() {
    this.batchTimeout && (clearTimeout(this.batchTimeout), this.batchTimeout = null), this.processBatch();
  }
  // Get current batch status
  getStatus() {
    return {
      queueLength: this.batchQueue.length,
      hasTimeout: !!this.batchTimeout
    };
  }
  // Clear all pending requests
  clear() {
    this.batchTimeout && (clearTimeout(this.batchTimeout), this.batchTimeout = null), this.batchQueue.forEach((e) => {
      e.reject(new Error("Batch cleared"));
    }), this.batchQueue = [];
  }
}
const ae = new oe();
async function ce(t) {
  return ae.addRequest(t);
}
export {
  ce as f,
  re as g,
  ie as i,
  se as r,
  _ as s
};
